import { Permission } from '../../types/permissions';

/** Anyone who can see a booking at all: the narrow read grant, or the breadth
 *  grant that subsumes it. Shared so `AdminRoutes`'s route gate and the
 *  create-booking launcher's navigation guard can't drift apart. */
export const READ_BOOKINGS_PERMISSIONS = [Permission.READ_BOOKINGS, Permission.READ_ALL];
